module.exports = __webpack_public_path__ + "img/06b03cd.png";